// Phase 2 — semantic stroke width (border width) tokens
//
// Currently every component hardcodes borderWidth: 1 (or 2) as a raw pixel value.
// This token set will replace all hardcoded borderWidth values once the
// bsky/tokens/strokeWidth collection is added to Figma.
//
// Proposed scale (pending design confirmation — see FIGMA_DESIGN_SYSTEM_UPDATES.md Part 4):
//
//   hairline  ~0.33–0.5px  StyleSheet.hairlineWidth — hairline separators on native
//   thin      1px           default border: inputs, cards, dividers
//   medium    2px           focused/selected states, strong dividers
//   thick     3px           emphasis borders, error states
//
// Note: strokeWidth values are theme-independent (same in dark and light mode).
// They will NOT be part of semanticTokens once added — they belong in a
// separate primitive export consumed directly, similar to ALF spacing atoms.

export const strokeWidth = {} as const

export type StrokeWidth = typeof strokeWidth
